module.exports = __webpack_public_path__ + "img/preheat_bg_img.6e342710.png";